<div class="arrows">
    <div class="up-arrow" [class.active]="direction === 'asc' && active"></div>
    <div class="down-arrow" [class.active]="direction === 'desc' && active"></div>
</div>